import { Mutations } from '@/util/settings/enums';
const mutations = {
    [Mutations.SET_FORM_API_LOADING](state, data) {
        state.isFormApiLoading = data;
    },
    [Mutations.SET_FORM_API_ERROR](state, data) {
        state.setFormApiError = data.isError;
        state.apiErrorCode = data.statusCode;
    }
};
export default mutations;
